import React, { useContext, useState, useEffect } from "react";

import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import {NotificationsContext} from "../ui-components/Notifications";
import ReferencesTable from "../components/Tables/ReferencesTable";
import {PageHeading} from "../ui-components/Container";
import Placeholder from "../ui-components/Placeholder";
import {useIntl} from "react-intl";
import CountryContext from "../CountryContext";
import UserNotificationsContext from "../UserNotificationsContext";

const References = () => {
  const {userNotifications} = useContext(UserNotificationsContext);
  const {country} = useContext(CountryContext);
  const { push } = useContext(NotificationsContext);
  const countryApiRequest = useCountryAxiosInstance();

  const [references, setReferences] = useState();
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [refs, worksites] = await Promise.all([
          countryApiRequest.get("/reference"),
          countryApiRequest.get("/worksites/reported"),
        ]);
        const extendedReferences = refs.map((r) => {
          const notification = userNotifications
            ?.find((n) => n.val_type === 'worksite_reference' && n.cod_reference === r.id);
          return {
            ...r,
            isNew: !!notification,
            notificationTimestamp: notification
              ? new Date(notification.created_at)
              : new Date('0001-01-01T00:00:00Z'),
          }
        });
        const adaptedWorksites = worksites
          ?.filter((w) => !refs.some((r) => r.cod_worksite_id === w.id))
          ?.map((w) => {
            const notification = userNotifications
              ?.find((n) => n.val_type === 'worksite_reference_report' && n.cod_worksite === w.id);
            return {
              address: w.address,
              city: w.city,
              cod_province: w.cod_province,
              cod_worksite_id: w.id,
              created_at: w.created_at,
              is_report: true,
              hasNotification: !!notification,
              status: 'reported_f',
              worksiteStatus: Object.values(w.cod_worksite_status).reduce(
                (prev, curr) => curr.flg_active && !!curr.date ? curr.step : prev,
                "planning"
              ),
              notificationTimestamp: notification
                ? new Date(notification.created_at)
                : new Date('0001-01-01T00:00:00Z'),
            }
          });
        // update state
        setReferences(extendedReferences.concat(adaptedWorksites));
      } catch (error) {
        push({title: intl.formatMessage({ id: "server_error" }), type: "error"});
        throw error;
      }
    };

    if (!references) {
      fetchData()
    }

  }, [references, userNotifications]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-full pt-4 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center w-full mx-auto">
        <PageHeading
          title={intl.formatMessage({id: "references"})}
        />
        {(!references) ?
          <div className="flex flex-col w-full mb-4">
            <Placeholder height="h-60" classNames="mb-4 rounded-lg" />
            <Placeholder height="h-60" classNames="rounded-lg" />
          </div> :
          <div>
            {references.length ?
              <div>
                <ReferencesTable
                  references={references}
                  setReferences={setReferences}
                  countryCode={country.code}
                  countryApiRequest={countryApiRequest}
                  push={push}
                  intl={intl}
                />
              </div> :
              <div className="text-center m-10 rounded-lg shadow py-5">
                {intl.formatMessage({id: "no_references"})}
              </div>
            }
          </div>
        }
      </main>
    </div>
  );
};

export default References;
